import React from "react";
import { RecordIcon, LightTooltip, LongText } from "../../../../Component";

export const TableHeader = (t) =>([
  {
    title: t("labels.checks.table.headers.jllCountry"),
    field: "country_iso_code_3",
    cellStyle: { width: 100 },
    headerStyle: { width: 100, maxWidth: 200 },
    render: (rowData) => (
      <LightTooltip
        title={rowData.jllCountry}
        placement="top-start"
        style={{ paddingBottom: 0, paddingTop: 0 }}
      >
        <span style={{ width: 100 }}>{rowData.country_iso_code_3}</span>
      </LightTooltip>
    ),
  },
  {
    title: t("labels.checks.table.headers.recordName"),
    field: "name",
    render: (rowData) => (
      <LongText text={rowData.name} width="200px" />
    ),
  },
  {
    title: t("labels.checks.table.headers.recordType"),
    field: "recordType",
    render: (rowData) => {
      return <RecordIcon entityCategory={rowData.recordType} t={t}/>
    },
  },
  {
    title: t("labels.checks.table.headers.checkType"),
    field: "checkType",
    render: (rowData) => {
      return t(`labels.checks.${rowData.checkType}`)
    },
  },

  {
    title: t("labels.checks.table.headers.requestor"),
    field: "requestor",
  },
  {
    title: t("labels.checks.table.headers.assigned"),
    field: "assigned"
  },
]);
